export default __webpack_public_path__ + "static/media/zoom-in-enabled.3de7810d.svg";